import React, { Component } from 'react'; // import classNames from 'classnames';
// import dateFormat from 'dateformat';

import './section.scss';

class Section extends Component {
  render() {
    var {
      children,
      label
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: "sectionContainer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "sectionLabel"
    }, label), /*#__PURE__*/React.createElement("div", null, children));
  }

}

export default Section;